import styled from 'styled-components'

export const Container = styled.div`
    width: 100%;
    padding: 0 2px 0;
`

export const ContentLoader = styled.div`
    width: ${props => (props.width ?? '100%')}!important;
    height: ${props => (props.height ?? '100%')}!important;
    border-radius: ${props => (props.circle ? '50%' : '8px')};
    height: ${props => (props.height ?? '14px')}!important;
    background: transparent;
    margin: ${props => (props.margin ?? '0')};
    margin-top: ${props => (props.marginTop ?? '0')};
    margin-right: ${props => (props.marginRight ?? '0')};
    margin-bottom: ${props => (props.marginBottom ?? '0')};
    margin-left: ${props => (props.marginLeft ?? '0')};
    position: relative;
    overflow: hidden;
    
    @keyframes load {
        from {
            left: -100%;
        }
        to   {
            left: 100%;
        }
    }

    &::before {
        content: '';
        position: absolute;
        height: 100%;
        width: 100%;
        background: ${props => (props.color
        ? `linear-gradient(to right, transparent 0%, ${props.color} 50%, transparent 100%)`
        : `linear-gradient(to right, ${props.theme.skeleton[1]} 0%, ${props.theme.skeleton[0]} 50%, ${props.theme.skeleton[1]} 100%)`
        )};
        animation: load 2s ease-in infinite;
    }   

`
/**

width: ${props => (props.height ?? '100%')}!important;

    height: ${props => (props.height ?? '14px')}!important;
    box-shadow: 0 4px 10px 0 rgba(33, 33, 33, 0.15);
    border-radius: 4px;
    position: relative;
    overflow: hidden;
    
    @keyframes load {
        from {
            left: -150px;
        }
        to   {
            left: 100%;
        }
    }

    &::before {
        content: '';
        display: block;
        position: absolute;
        left: -150px;
        top: 0;
        height: 100%;
        width: 150px;
        background: ${props => (props.color
        ? `linear-gradient(to right, transparent 0%, ${props.color} 50%, transparent 100%)`
        : `linear-gradient(to right, transparent 0%, ${props.theme.title} 50%, transparent 100%)`
        )};
        animation: load 1s ease-out infinite;
    }   

 */